import React from "react";

import { Image } from "../../../common/Image";
import { IValueProp } from "../../../models/catalogue.interfaces";

import styles from "./BasketLineValueProps.module.scss";

export const BasketLineValueProps = (props: {
    valueProps: IValueProp[];
    isMobile: boolean;
}): React.ReactNode => {
    const valueProps = props.isMobile
        ? props.valueProps.slice(0, 2)
        : props.valueProps;
    return (
        <ul className={styles.list}>
            {valueProps.map((valueProp) => (
                <li className={styles.prop} key={valueProp.name}>
                    <Image
                        className={styles.image}
                        src={valueProp.image_url}
                        alt=""
                    />
                    {/* TODO(i18n): Value prop descriptions from backend are not translated. Backend should either (1) store translations in database or (2) use gettext in serializer to translate description field before sending to frontend */}
                    <span className={styles.text}>{valueProp.description}</span>
                </li>
            ))}
        </ul>
    );
};
